let i18nInstance = null;

export function injectI18n(i18n) {
  i18nInstance = i18n;
}

export function t(key) {
  if (!i18nInstance) {
    console.warn('[i18nInject] i18n not injected yet, fallback to raw key:', key);
    return key;
  }
  return i18nInstance.t(key);
}